import PropTypes from "prop-types";
import { useFormContext, Controller } from "react-hook-form";

export default function RHFCheckboxGroup({ name, options = [], label }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => {
                const handleChange = (event) => {
                    const { value, checked } = event.target;
                    const currentValues = field.value || [];

                    if (checked) {
                        field.onChange([...currentValues, value]);
                    } else {
                        field.onChange(
                            currentValues.filter((v) => v !== value)
                        );
                    }
                };

                return (
                    <div className="flex flex-col gap-2">
                        {label && (
                            <p className="text-sm font-semibold text-gray-700">
                                {label}
                            </p>
                        )}

                        <div className="flex flex-wrap gap-3">
                            {options.map((option) => {
                                const checked =
                                    field.value?.includes(option.value) ||
                                    false;
                                return (
                                    <label
                                        key={option.value}
                                        className="inline-flex items-center gap-2 rounded-md border border-gray-200 bg-white px-3 py-2 shadow-sm transition hover:border-primary/40 hover:shadow-md"
                                    >
                                        <input
                                            type="checkbox"
                                            value={option.value}
                                            checked={checked}
                                            onChange={handleChange}
                                            className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary focus:ring-offset-0"
                                        />
                                        <span className="text-sm font-medium text-gray-700">
                                            {option.label}
                                        </span>
                                    </label>
                                );
                            })}
                        </div>

                        {error && (
                            <p
                                style={{
                                    color: "red",
                                    marginTop: "0.25rem",
                                    fontSize: "0.875rem",
                                }}
                            >
                                {error.message}
                            </p>
                        )}
                    </div>
                );
            }}
        />
    );
}

RHFCheckboxGroup.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
        })
    ),
};
